module.exports = __webpack_public_path__ + "static/media/horizontal-white.f8d271f0.svg";